export const replaceOrAdd = <T>(array: T[], matcher: (elem: T) => boolean, replacer: (elem?: T) => T): [T[], T] => {
  const itemIdx = array.findIndex(matcher);
  const foundElem = array[itemIdx];
  const replacement = replacer(foundElem);

  if (itemIdx === -1) {
    return [[...array, replacement], replacement];
  }

  const modifiedArray = array.slice();
  modifiedArray.splice(itemIdx, 1, replacement);

  return [modifiedArray, replacement];
};

export const groupBy = <T, K extends keyof T>(array: T[], key: K): Record<string, T[]> => {
  return array.reduce(
    (acc, elem) => {
      const currentKey = String(elem[key]);
      const current = acc[currentKey] || [];

      return {
        ...acc,
        [currentKey]: [...current, elem],
      };
    },
    {} as Record<string, T[]>,
  );
};
